import { getClient } from '@/lib/restClient';
import { StoreManagementMasterStoreService } from '@/services/StoreManagement/MasterStores/StoreManagementMasterStoreService';

export type StoreManagementMasterStoreCreateParams = {
  name: string;
  auth_store_id: number;
  associate_brand_id: number;
  business_number: string | null;
  business_name: string | null;
};

export type StoreManagementMasterStoreCreateResponse = {
  id: number;
};

export const useStoreManagementMasterStoreCreate = async (
  params: StoreManagementMasterStoreCreateParams
): Promise<StoreManagementMasterStoreCreateResponse> => {
  const storeManagementMasterStoreService =
    new StoreManagementMasterStoreService(getClient());
  return await storeManagementMasterStoreService.create(params);
};
